import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _15e20773 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _1b80b0ab = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _423c1ace = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _d0ebc4e0 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _92314ba0 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _24304b46 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _8e4904f8 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _3236255f = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _3db5aca8 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _577d7149 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _25abc35d = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _d7f5e25a = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _ac38424e = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _30891f30 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _d5e0b4b0 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _0bd15593 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _987cf88c = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _0192ad70 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _f676362a = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _f3ef976a = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _d554a3cc = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _50ebd4fc = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _deeaa694 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _11c3b012 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _3fdc6206 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _d390db70 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _1cc2348a = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _63d9d878 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _b8600c54 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _28f3d85c = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _f6c1ebee = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _455e01e4 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _1b3de5e5 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _c8cd0fc6 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _1a4bb49f = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _3c9eac36 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _413bd680 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _03d9db3e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _1158e0c0 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _0ac769a0 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _45193ba0 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _22916488 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _8b5678fa = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _70a8d9ec = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _94a636e6 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _6537c359 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _5f7ed5fa = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _3557a6c6 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _09fc6436 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _0535582f = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _6a8402f6 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _02a201be = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _67fe4861 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _50ff77d3 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _78fe8df4 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _62fa82eb = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _ecf295d0 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _b7cbba72 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _045f56fe = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _5b796d29 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _76e49be6 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _027398e0 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _6c661d8d = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _771e4476 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _71ee4728 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _adbd6aca = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _47e30e94 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _e558ffe8 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _3033aed0 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _4ed28de0 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _6dc60df6 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _d1e5e36e = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _549d0e46 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _329ebf0b = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _83d1e566 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _311ea9fb = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _15e20773,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _1b80b0ab,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _423c1ace,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _d0ebc4e0,
    name: "calendar"
  }, {
    path: "/customer",
    component: _92314ba0,
    name: "customer"
  }, {
    path: "/details",
    component: _24304b46,
    name: "details"
  }, {
    path: "/goals",
    component: _8e4904f8,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _3236255f,
    name: "maisoku"
  }, {
    path: "/media",
    component: _3db5aca8,
    name: "media"
  }, {
    path: "/privacy",
    component: _577d7149,
    name: "privacy"
  }, {
    path: "/project",
    component: _25abc35d,
    name: "project"
  }, {
    path: "/response",
    component: _d7f5e25a,
    name: "response"
  }, {
    path: "/sale",
    component: _ac38424e,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _30891f30,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _d5e0b4b0,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _0bd15593,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _987cf88c,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _0192ad70,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _f676362a,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _f3ef976a,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _d554a3cc,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _50ebd4fc,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _deeaa694,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _11c3b012,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _3fdc6206,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _d390db70,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _1cc2348a,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _63d9d878,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _b8600c54,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _28f3d85c,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _f6c1ebee,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _455e01e4,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _1b3de5e5,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _c8cd0fc6,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _1a4bb49f,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _3c9eac36,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _413bd680,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _03d9db3e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _1158e0c0,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _0ac769a0,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _45193ba0,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _22916488,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _8b5678fa,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _70a8d9ec,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _94a636e6,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _6537c359,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _5f7ed5fa,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _3557a6c6,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _09fc6436,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _0535582f,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _6a8402f6,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _02a201be,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _67fe4861,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _50ff77d3,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _78fe8df4,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _62fa82eb,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _ecf295d0,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _b7cbba72,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _045f56fe,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _5b796d29,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _76e49be6,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _027398e0,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _6c661d8d,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _771e4476,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _71ee4728,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _adbd6aca,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _47e30e94,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _e558ffe8,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _3033aed0,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _4ed28de0,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _6dc60df6,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _d1e5e36e,
    name: "property-property",
    children: [{
      path: "contact",
      component: _549d0e46,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _329ebf0b,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _83d1e566,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _311ea9fb,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
